const IconCreate = () => (
  <svg
    width="41px"
    height="50px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.035 30.702a3.545 3.545 0 0 0-3.44 2.686l-.318 1.276a2.242 2.242 0 1 1-4.351-1.086l.318-1.277a8.03 8.03 0 0 1 7.79-6.084h6.923a8.03 8.03 0 0 1 7.777 6.035l.337 1.312a2.242 2.242 0 1 1-4.344 1.114l-.337-1.312a3.545 3.545 0 0 0-3.433-2.664h-6.922Z"
      fill="#5FA3A9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5 8.807a7.547 7.547 0 1 0 0 15.093 7.547 7.547 0 0 0 0-15.093Zm-3.93 7.546a3.93 3.93 0 1 1 7.86 0 3.93 3.93 0 0 1-7.86 0Z"
      fill="#5FA3A9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.29 5.367 21.984.803h-1.18L2.494 5.367c-.466.143-.85.42-1.155.832-.304.411-.456.904-.456 1.476v18.308c0 3.722.984 7.104 2.953 10.147 1.968 3.006 4.152 5.592 6.55 7.758 2.398 2.165 4.635 3.856 6.71 5.073 2.112 1.217 3.276 1.879 3.49 1.986.108.143.233.224.376.242.143.018.322.027.537.027.215 0 .394-.01.537-.027.143-.018.268-.099.376-.242.215-.107 1.378-.77 3.49-1.986 2.075-1.217 4.312-2.908 6.71-5.073 2.398-2.166 4.582-4.752 6.55-7.758 1.969-3.043 2.953-6.425 2.953-10.147V7.675c0-.572-.161-1.065-.483-1.476-.322-.412-.77-.69-1.342-.832Zm-2.737 20.616c0 2.577-.662 4.993-1.987 7.247a29.378 29.378 0 0 1-4.67 5.96c-1.79 1.754-3.58 3.257-5.37 4.51-1.753 1.216-3.095 2.111-4.026 2.684-.93-.501-2.273-1.36-4.026-2.577-1.79-1.181-3.58-2.658-5.37-4.43a29.404 29.404 0 0 1-4.67-6.04c-1.324-2.254-1.987-4.706-1.987-7.354V9.5L21.5 5.367 37.553 9.5v16.482Z"
      fill="#5FA3A9"
    />
  </svg>
);

export default IconCreate;
